import React from 'react'
import Image from 'next/image'

interface HeaderTitleProps {
	title: string
	subtitle: string
	headerImg: StaticImageData
	children?: React.ReactNode
}

const HeaderTitle: React.FC<HeaderTitleProps> = ({
	title,
	subtitle,
	headerImg,
	children = null,
}: HeaderTitleProps) => {
	return (
		<div className="relative h-full z-20 bg-purple-900">
			<div className="container mx-auto px-4 pt-8 md:pt-20 pb-32 relative z-20">
				<div className="w-full md:w-1/2 mt-4">
					<h1 className="text-3xl md:text-5xl mb-4 font-sans font-bold text-white">
						{title}
					</h1>
					<h2 className="text-lg md:text-xl mb-4 font-sans font-normal text-white opacity-75">
						{subtitle}
					</h2>

					{children}
				</div>
			</div>
			<div className="bg-gradient-to-b md:bg-gradient-to-r z-10 absolute from-purple-900 h-1/2 md:h-full right-0 bottom-0 top-auto md:top-0 w-full md:w-7/12"></div>
			<div className="absolute right-0 bottom-0 top-auto md:top-0 h-1/2 md:h-full w-full md:w-7/12">
				<Image
					layout="fill"
					objectFit="cover"
					objectPosition="center"
					src={headerImg}
					alt="Problem solving"
				/>
			</div>
		</div>
	)
}

export default HeaderTitle
